import { clientGetWrapper, clientPostWrapper, clientPostWrapperWithOutTracking } from "../api/Api";
import {
    INFLUIO_TV_EPISODES, INFLUIO_TV_IMAGE, INFLUIO_TV_SCRIPT, INFLUIO_TV_TTS, INFLUIO_TV_WITHDRAW_EPISODE
} from "../common/constants/routes";

export const KARACA_OFFER_ID = 123;

// untracked on purpose: the studio has its own progress UI, and the global spinner would
// blank the stage while Lia writes and while the take uploads
export const generateScript = ({ salesDay, offerId = KARACA_OFFER_ID, notes = '' }) =>
    clientPostWrapperWithOutTracking(INFLUIO_TV_SCRIPT, { salesDay, offerId, notes });

export const listEpisodes = (offerId = KARACA_OFFER_ID) =>
    clientGetWrapper(INFLUIO_TV_EPISODES, { offerId });

/** multipart: video + offerId + date + title + transcript */
export const saveEpisode = (formData) =>
    clientPostWrapperWithOutTracking(INFLUIO_TV_EPISODES, formData, true);

export const withdrawEpisode = (id) =>
    clientPostWrapper(INFLUIO_TV_WITHDRAW_EPISODE, { id });

/** Plain fetch, no spinner: the studio renders six of these at once and a global
 * spinner over the stage would be noise. Resolves to a WAV blob. */
export const fetchVoiceBlob = async (text, voice) => {
    const r = await fetch(process.env.REACT_APP_DASHBOARD_API + INFLUIO_TV_TTS, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ text, voice }),
    });
    if (!r.ok) throw new Error(`tts ${r.status}`);
    return r.blob();
};

/** A product photo from the Karaca CDN, via the server (the CDN sends no CORS headers, and
 * a canvas painted with a cross-origin image could not be taped). */
export const fetchImageBlob = async (src) => {
    const r = await fetch(`${process.env.REACT_APP_DASHBOARD_API}${INFLUIO_TV_IMAGE}?src=${encodeURIComponent(src)}`, { credentials: 'include' });
    if (!r.ok) throw new Error(`image ${r.status}`);
    return r.blob();
};
